// @ts-nocheck
import * as React from "react";
import anime from "animejs/lib/anime.es.js";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import ModalInfo from "../modalInfo";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

const elementList = [
    <img className='af-bg-aditional__cloud' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube1.png`} alt="" title="" />,
    <img className='af-bg-aditional__cloud2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube3.png`} alt="" title="" />,
]

export const Participar = ({ data, setLoading, loading }: any) => {

    const urlUserParticipate = new URL(location.href)?.searchParams?.get("userParticipate");

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    const animateSky = () => {
        anime({
            targets: '.af-bg-aditional__cloud',
            translateX: 100,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 20000,
        })

        anime({
            targets: '.af-bg-aditional__cloud2',
            translateX: -50,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 10000,
        })
    }

    React.useEffect(() => {
        animateSky()
    })

    return (
        <main>
            <ModalInfo
                title={'Inscripción exitosa'}
                subtitle={'El dibujo fue subido.'}
                desc={'Un moderador revisará el dibujo. Por correo te estaremos avisando cuando  sea aprobado'}
                desc2={'Por el momento puedes inscribir a otro niño/a o explorar la galeria y votar por la obra que más te guste'}
                inscription={urlUserParticipate == 'true'}
            />
            <div className='boxAllies'>
                <Banner
                    backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/register/banner.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/contact/contactoMobile.jpg` }}
                    textBanner={!loading ? `¡Hola ${localStorage.getItem('nameUser') == '' ? '' : localStorage.getItem('nameUser')}!` : ''}
                    textDescription={data.field_desc}
                    componentsAnimated={elementList}
                    newBanner={1}
                />
            </div>
            <div className="background-contact">
                {/* <FishSec /> */}
                <div id="newFormParticipante" className="form" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement='top-bottom'>
                    <h2 className="form__title">1. DATOS PERSONALES (Participante)</h2>
                </div>
            </div>
        </main>
    )
}

export default Loader(Participar)
